var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgL2Dkxc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1081_1800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4349 31.5212H18.1994C17.5314 31.5212 16.99 30.9797 16.99 30.3118V10.6626C16.99 9.9947 17.5314 9.45325 18.1994 9.45325H33.4349C34.1028 9.45325 34.6443 9.9947 34.6443 10.6626V30.3118C34.6443 30.9797 34.1028 31.5212 33.4349 31.5212Z",
    fill: "url(#paint0_linear_1081_1800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.167 29.5028V11.4717C18.167 11.0534 18.5061 10.7144 18.9243 10.7144H32.7101C33.1283 10.7144 33.4674 11.0534 33.4674 11.4717V29.5029C33.4674 29.9211 33.1283 30.2602 32.7101 30.2602H18.9243C18.5061 30.2601 18.167 29.9211 18.167 29.5028Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4058 10.7143H30.233V9.61328C30.233 9.17669 29.879 8.82273 29.4424 8.82273H28.3436C28.3436 7.42985 27.2145 6.30066 25.8216 6.30066C24.4287 6.30066 23.2995 7.42978 23.2995 8.82273H22.1963C21.7597 8.82273 21.4058 9.17669 21.4058 9.61328L21.4058 10.7143Z",
    fill: "url(#paint1_linear_1081_1800)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30.2329 10.7144L21.4036 12.6059V10.7144H30.2329Z",
    fill: "url(#paint2_linear_1081_1800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6204 14.1382H20.5508C19.9635 14.1382 19.4873 14.6143 19.4873 15.2017V16.2713C19.4873 16.8586 19.9635 17.3347 20.5508 17.3347H21.6204C22.2077 17.3347 22.6839 16.8586 22.6839 16.2713V15.2017C22.6839 14.6143 22.2078 14.1382 21.6204 14.1382Z",
    fill: "url(#paint3_linear_1081_1800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5806 16.494L20.0755 15.989C19.9361 15.8495 19.9361 15.6234 20.0755 15.4839C20.215 15.3445 20.4411 15.3445 20.5806 15.4839L20.8331 15.7364L21.5906 14.9789C21.7301 14.8394 21.9562 14.8394 22.0957 14.9789C22.2351 15.1183 22.2351 15.3445 22.0957 15.4839L21.0856 16.494C20.9462 16.6335 20.7201 16.6335 20.5806 16.494Z",
    fill: "#E1FFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5941 14.5636H24.0507C23.7751 14.5636 23.5518 14.787 23.5518 15.0625C23.5518 15.338 23.7751 15.5614 24.0507 15.5614H27.5941C27.8696 15.5614 28.093 15.338 28.093 15.0625C28.0931 14.787 27.8697 14.5636 27.5941 14.5636Z",
    fill: "url(#paint4_linear_1081_1800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6521 16.3368H24.0507C23.7751 16.3368 23.5518 16.5602 23.5518 16.8357C23.5518 17.1112 23.7751 17.3346 24.0507 17.3346H31.6521C31.9277 17.3346 32.151 17.1112 32.151 16.8357C32.1511 16.5602 31.9277 16.3368 31.6521 16.3368Z",
    fill: "url(#paint5_linear_1081_1800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6204 18.8889H20.5508C19.9635 18.8889 19.4873 19.3651 19.4873 19.9525V21.022C19.4873 21.6093 19.9635 22.0855 20.5508 22.0855H21.6204C22.2077 22.0855 22.6839 21.6093 22.6839 21.022V19.9525C22.6839 19.3651 22.2078 18.8889 21.6204 18.8889Z",
    fill: "url(#paint6_linear_1081_1800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5806 21.2447L20.0755 20.7397C19.9361 20.6002 19.9361 20.3741 20.0755 20.2346C20.215 20.0952 20.4411 20.0952 20.5806 20.2346L20.8331 20.4871L21.5906 19.7296C21.7301 19.5901 21.9562 19.5901 22.0957 19.7296C22.2351 19.8691 22.2351 20.0952 22.0957 20.2346L21.0856 21.2447C20.9462 21.3841 20.7201 21.3841 20.5806 21.2447Z",
    fill: "#E1FFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5941 19.3143H24.0507C23.7751 19.3143 23.5518 19.5377 23.5518 19.8132C23.5518 20.0888 23.7751 20.3122 24.0507 20.3122H27.5941C27.8696 20.3122 28.093 20.0888 28.093 19.8132C28.0931 19.5377 27.8697 19.3143 27.5941 19.3143Z",
    fill: "url(#paint7_linear_1081_1800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6521 21.0875H24.0507C23.7751 21.0875 23.5518 21.3109 23.5518 21.5864C23.5518 21.862 23.7751 22.0853 24.0507 22.0853H31.6521C31.9277 22.0853 32.151 21.862 32.151 21.5864C32.1511 21.3109 31.9277 21.0875 31.6521 21.0875Z",
    fill: "url(#paint8_linear_1081_1800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6204 23.6398H20.5508C19.9635 23.6398 19.4873 24.1159 19.4873 24.7033V25.7729C19.4873 26.3602 19.9635 26.8363 20.5508 26.8363H21.6204C22.2077 26.8363 22.6839 26.3602 22.6839 25.7729V24.7033C22.6839 24.1159 22.2078 23.6398 21.6204 23.6398Z",
    fill: "url(#paint9_linear_1081_1800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5806 25.9956L20.0755 25.4906C19.9361 25.3511 19.9361 25.125 20.0755 24.9855C20.215 24.846 20.4411 24.846 20.5806 24.9855L20.8331 25.238L21.5906 24.4805C21.7301 24.341 21.9562 24.341 22.0957 24.4805C22.2351 24.6199 22.2351 24.846 22.0957 24.9855L21.0856 25.9956C20.9462 26.1351 20.7201 26.1351 20.5806 25.9956Z",
    fill: "#E1FFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5941 24.0652H24.0507C23.7751 24.0652 23.5518 24.2886 23.5518 24.5641C23.5518 24.8396 23.7751 25.063 24.0507 25.063H27.5941C27.8696 25.063 28.093 24.8396 28.093 24.5641C28.0931 24.2886 27.8697 24.0652 27.5941 24.0652Z",
    fill: "url(#paint10_linear_1081_1800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6521 25.8384H24.0507C23.7751 25.8384 23.5518 26.0618 23.5518 26.3373C23.5518 26.6128 23.7751 26.8362 24.0507 26.8362H31.6521C31.9277 26.8362 32.151 26.6128 32.151 26.3373C32.1511 26.0618 31.9277 25.8384 31.6521 25.8384Z",
    fill: "url(#paint11_linear_1081_1800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0898 24.9326L24.4645 24.7C24.3182 24.6077 24.1999 24.4714 24.1349 24.3008L24.0993 24.2073C24.0911 24.1856 24.0851 24.1639 24.0789 24.1421L23.8447 24.2875L24.0898 24.9326Z",
    fill: "#FA8C16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2164 24.7834L26.0485 24.4874C26.4112 24.3583 26.6364 24.0073 26.595 23.636L26.5707 23.42C26.5407 23.1513 26.2905 22.9574 26.0126 22.9871L24.7971 23.1171C24.2533 23.1753 23.9102 23.7112 24.0993 24.2073L24.1349 24.3008C24.2956 24.7226 24.7799 24.9387 25.2164 24.7834Z",
    fill: "#FFB950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.64334 24.9325L5.26862 24.6998C5.41492 24.6076 5.53327 24.4713 5.59829 24.3007L5.63383 24.2072C5.6421 24.1855 5.64803 24.1638 5.65423 24.142L5.88843 24.2874L5.64334 24.9325Z",
    fill: "#FA8C16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.51675 24.7833L3.68469 24.4873C3.32192 24.3582 3.09671 24.0071 3.1382 23.6358L3.16246 23.4198C3.1925 23.1512 3.44266 22.9573 3.72052 22.987L4.93603 23.117C5.4799 23.1752 5.82295 23.7111 5.63385 24.2072L5.59829 24.3007C5.43758 24.7224 4.95326 24.9386 4.51675 24.7833Z",
    fill: "#FFB950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02773 33.8991C5.42832 33.8991 4.8901 33.6511 4.51245 33.2573V35.0095C4.51245 35.4153 4.85289 35.7441 5.27271 35.7441H7.55363C7.97359 35.7441 8.31388 35.4152 8.31388 35.0095V33.8991H6.02773Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6698 33.8987H21.3835V35.0093C21.3835 35.4151 21.724 35.7439 22.1438 35.7439H24.4247C24.8447 35.7439 25.185 35.415 25.185 35.0093V33.2568C24.8075 33.6508 24.2692 33.8987 23.6698 33.8987Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02762 33.8991L23.6696 33.8988C24.8114 33.8988 25.737 33.0044 25.737 31.9012V28.2718C25.737 27.752 25.5796 27.2436 25.2841 26.8091L24.1938 25.2058H5.50346L4.41311 26.8091C4.1176 27.2436 3.96021 27.752 3.96021 28.2718V31.9013C3.96007 33.0047 4.88572 33.8991 6.02762 33.8991Z",
    fill: "#FFB950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.737 28.2719C25.737 27.7521 25.5796 27.2437 25.2841 26.8093L24.1937 25.2059H23.9575L24.5951 26.1434C24.8906 26.5778 25.048 27.0863 25.048 27.606V31.2354C25.048 32.3386 24.1223 33.233 22.9805 33.233L5.33856 33.2333C4.94437 33.2333 4.57734 33.1248 4.26392 32.9399C4.62695 33.5144 5.27998 33.8992 6.0277 33.8992L23.6697 33.8989C24.8114 33.8989 25.7371 33.0045 25.7371 31.9013L25.737 28.2719Z",
    fill: "#FA8C16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8781 30.9793H11.8189C11.5061 30.9793 11.2323 30.7755 11.1525 30.4832L10.8269 29.2897C10.7116 28.8674 11.0412 28.454 11.4933 28.454H18.2038C18.6558 28.454 18.9854 28.8674 18.8702 29.2897L18.5445 30.4832C18.4647 30.7755 18.1911 30.9793 17.8781 30.9793Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9591 25.9882L23.5835 25.3418C23.5347 25.2578 23.4428 25.2058 23.3431 25.2058H6.35388C6.25423 25.2058 6.1623 25.2578 6.11351 25.3418L5.73793 25.9882C5.52898 26.3478 5.70512 26.8026 6.10703 26.9412L8.97261 27.9302C9.12133 27.9816 9.27818 28.0079 9.43613 28.0079H20.2606C20.4185 28.0079 20.5754 27.9816 20.7241 27.9302L23.5897 26.9412C23.9919 26.8026 24.168 26.3478 23.9591 25.9882Z",
    fill: "#FA8C16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4559 29.0107C20.9991 28.4924 22.2391 27.6647 24.642 27.6238C24.7582 27.6218 24.8637 27.6923 24.9045 27.7975C25.0551 28.1864 25.2992 29.1069 24.3621 29.3585C23.4739 29.5968 21.5612 29.5171 20.6318 29.4599C20.3971 29.4454 20.2886 29.1703 20.4559 29.0107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9046 27.7975C24.8638 27.6924 24.7583 27.6218 24.6421 27.6238C24.5625 27.6252 24.4874 27.6295 24.4102 27.6326C24.4835 28.0586 24.4205 28.5838 23.7475 28.7645C23.0141 28.9613 21.5833 28.9412 20.5831 28.8961C20.5375 28.9355 20.4945 28.9741 20.4559 29.0109C20.2886 29.1704 20.3972 29.4455 20.6318 29.4599C21.5613 29.5171 23.4739 29.597 24.3621 29.3585C25.2993 29.1069 25.0552 28.1864 24.9046 27.7975Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24086 29.0107C8.69768 28.4924 7.45764 27.6647 5.05475 27.6238C4.93856 27.6218 4.83312 27.6923 4.79232 27.7975C4.64168 28.1864 4.39758 29.1069 5.33468 29.3585C6.22284 29.5968 8.13562 29.5171 9.06499 29.4599C9.29971 29.4454 9.40818 29.1703 9.24086 29.0107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24077 29.0107C9.1068 28.8828 8.92983 28.7361 8.70393 28.5869C8.71151 28.7216 8.61228 28.8558 8.45033 28.8658C7.52082 28.9229 5.60818 29.0028 4.72002 28.7643C4.70486 28.7603 4.69259 28.7546 4.67798 28.7502C4.74372 29.0135 4.92758 29.2491 5.33459 29.3583C6.22275 29.5967 8.13553 29.5169 9.06491 29.4598C9.29963 29.4454 9.4081 29.1702 9.24077 29.0107Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9563 19.1218H9.74066C8.58484 19.1218 7.55182 19.8185 7.15322 20.8668L5.50342 25.2058H24.1937L22.5439 20.8668C22.1452 19.8186 21.1122 19.1218 19.9563 19.1218Z",
    fill: "#FFB950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56264 24.0586L7.72976 21.0413C7.93113 20.5208 8.44578 20.1758 9.0208 20.1758H20.6762C21.2512 20.1758 21.7659 20.5208 21.9673 21.0413L23.1344 24.0586C23.2018 24.2326 23.0685 24.4181 22.8762 24.4181H6.82079C6.62852 24.4181 6.49524 24.2326 6.56264 24.0586Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9301 21.2412C15.7779 21.2412 15.6499 21.1219 15.6499 20.9749C15.6499 20.8278 15.7687 20.7085 15.921 20.7085H15.9301C16.0822 20.7085 16.2057 20.8278 16.2057 20.9749C16.2057 21.1219 16.0824 21.2412 15.9301 21.2412ZM14.8183 21.2412H9.02956C8.8774 21.2412 8.75391 21.1219 8.75391 20.9749C8.75391 20.8278 8.8774 20.7085 9.02956 20.7085H14.8183C14.9705 20.7085 15.094 20.8278 15.094 20.9749C15.094 21.1219 14.9705 21.2412 14.8183 21.2412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1344 24.0585L21.9673 21.0413C21.7771 20.5494 21.3071 20.2148 20.7706 20.1792L21.756 22.7267C21.8234 22.9008 21.6901 23.0863 21.4978 23.0863H6.93863L6.56264 24.0585C6.49524 24.2326 6.62852 24.4181 6.82079 24.4181H22.8761C23.0685 24.4181 23.2016 24.2326 23.1344 24.0585Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1344 24.0585L21.9673 21.0413C21.8359 20.7018 21.5709 20.4377 21.2431 20.2946C21.2555 20.3211 21.2675 20.3478 21.2781 20.3754L22.4452 23.3927C22.5126 23.5667 22.3794 23.7522 22.1871 23.7522H6.68117L6.56264 24.0585C6.49524 24.2326 6.62852 24.4181 6.82079 24.4181H22.8761C23.0685 24.4181 23.2016 24.2326 23.1344 24.0585Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5542 32.8326H8.14312C7.90991 32.8326 7.78215 32.5703 7.93059 32.3966L8.31595 31.9459C8.44689 31.7928 8.64164 31.7042 8.84728 31.7042H20.8502C21.0557 31.7042 21.2506 31.7929 21.3815 31.9459L21.7669 32.3966C21.9152 32.5704 21.7873 32.8326 21.5542 32.8326Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3116 33.0405C23.7526 33.0405 24.1102 32.6949 24.1102 32.2685C24.1102 31.8421 23.7526 31.4965 23.3116 31.4965C22.8705 31.4965 22.5129 31.8421 22.5129 32.2685C22.5129 32.6949 22.8705 33.0405 23.3116 33.0405Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3116 32.7384C23.5801 32.7384 23.7978 32.528 23.7978 32.2684C23.7978 32.0089 23.5801 31.7985 23.3116 31.7985C23.0431 31.7985 22.8254 32.0089 22.8254 32.2684C22.8254 32.528 23.0431 32.7384 23.3116 32.7384Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1081_1800",
    x1: 19.9849,
    y1: 12.4088,
    x2: 34.5759,
    y2: 25.5012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2646ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1081_1800",
    x1: 25.8195,
    y1: 6.51899,
    x2: 25.8195,
    y2: 10.6963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0013,
    stopColor: "#766E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1081_1800",
    x1: 30.0827,
    y1: 9.72787,
    x2: 21.1503,
    y2: 11.7942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDBFBA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1081_1800",
    x1: 22.2299,
    y1: 14.4288,
    x2: 19.9535,
    y2: 17.0303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BEFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33C4AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1081_1800",
    x1: 23.5516,
    y1: 15.0622,
    x2: 28.0929,
    y2: 15.0622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDBFBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1081_1800",
    x1: 23.5516,
    y1: 16.8359,
    x2: 32.1511,
    y2: 16.8359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDBFBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1081_1800",
    x1: 22.2299,
    y1: 19.1795,
    x2: 19.9535,
    y2: 21.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BEFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33C4AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1081_1800",
    x1: 23.5516,
    y1: 19.8137,
    x2: 28.0929,
    y2: 19.8137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDBFBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1081_1800",
    x1: 23.5516,
    y1: 21.5867,
    x2: 32.1511,
    y2: 21.5867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDBFBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1081_1800",
    x1: 22.2299,
    y1: 23.9303,
    x2: 19.9535,
    y2: 26.5318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BEFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33C4AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1081_1800",
    x1: 23.5516,
    y1: 24.5645,
    x2: 28.0929,
    y2: 24.5645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDBFBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1081_1800",
    x1: 23.5516,
    y1: 26.3375,
    x2: 32.1511,
    y2: 26.3375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDBFBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9797"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1081_1800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.6667,
    height: 34.6667,
    fill: "white",
    transform: "translate(2.8667 2.66663)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgL2Dkxc);
export default __webpack_public_path__ + "static/media/L2dkxc.bd1aae39203780ee5c874b21a683d7ec.svg";
export { ForwardRef as ReactComponent };